module.exports = __webpack_public_path__ + "static/media/6.27bd06fd.png";